module.exports = __webpack_public_path__ + "static/media/img_02.0230c255.png";